import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HostApp } from "./HostApp";
import { Landing } from "./Landing";
import { ParticipantApp } from "./ParticipantApp";
import { PresenterApp } from "./PresenterApp";
import "./styles.css";
import "./brand.css";

/* eslint-disable react-refresh/only-export-components */

function App() {
  const path = window.location.pathname;
  const isHostDomain = window.location.hostname === "host.podiyoum.com";
  if (path.startsWith("/present")) return <PresenterApp />;
  if (path.startsWith("/host") || (isHostDomain && path === "/")) return <HostApp />;
  const match = path.match(/^\/j\/([^/]+)$/);
  if (match) return <ParticipantApp secureToken={decodeURIComponent(match[1])} />;
  return <Landing />;
}

createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
